import React from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { SearchDataItem } from '../../../logic/domains/search.domain';
import { searchFilterAction } from '../../../store/actions/search.filter.actions';
import { useSearchData, useRecentClients } from '../../hooks/AppStateHook';
import { recentClientsReducer } from '../../../store/reducers/recent-clients.reducer/recent-clients.reducer';
import AdvancedSearchBar from './AdvancedSearchBar/AdvancedSearchBar';
import DashboardSearch from './DashboardSearch/DashboardSearch';

interface SearchProps {
	isAdvanced?: boolean;
}

type Props = SearchProps & RouteComponentProps;

export interface Client {
	displayName: string;
	planId: string | null;
	partyFid: string | null;
	customerNumber: string;
	customerToken: string;
	searchData: Array<SearchDataItem>;
}

export const Search = (props: Props) => {
	const searchData = useSearchData();
	const dispatch = useDispatch();
	const recentClients = useRecentClients();

	const onClientSelected = (
		profileNumber: string,
		profileToken: string,
		type: string
	) => {
		switch (type) {
			case 'plan':
				props.history.push(`/planProfile/${profileToken}`);
				break;
			default:
				window.location.href = `/online/adviser/${type}profile/${profileNumber}`;
		}
	};

	const handleSearchSubmit = (searchKeyword: string) => {
		dispatch(searchFilterAction(searchKeyword || undefined));
		props.history.push('/search');
	};

	const searchProps = {
		data: searchData,
		onSelectedFn: onClientSelected,
		onSearchSubmit: handleSearchSubmit,
		recentClients: recentClients.items,
	};

	return props.isAdvanced ? (
		<AdvancedSearchBar {...searchProps} />
	) : (
		<DashboardSearch {...searchProps} />
	);
};

export default withRouter(Search);
